/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StampRowType } from '../../models/stamp-row-type';
import { UserSelectionTagUserList } from '../../models/user-selection-tag-user-list';

export interface StampGetStampTagUserSelectionList$Params {

/**
 * GUID of the document
 */
  documentId?: string;

/**
 * GUID of the stamp
 */
  stampId?: string;

/**
 * GUID of the tag definition
 */
  tagDefinitionId?: string;

/**
 * GUID of the stamp row
 */
  stampRowId?: string;

/**
 * Stamp row type
 */
  stampRowType?: StampRowType;
}

export function stampGetStampTagUserSelectionList(http: HttpClient, rootUrl: string, params?: StampGetStampTagUserSelectionList$Params, context?: HttpContext): Observable<StrictHttpResponse<UserSelectionTagUserList>> {
  const rb = new RequestBuilder(rootUrl, stampGetStampTagUserSelectionList.PATH, 'get');
  if (params) {
    rb.query('documentId', params.documentId, {});
    rb.query('stampId', params.stampId, {});
    rb.query('tagDefinitionId', params.tagDefinitionId, {});
    rb.query('stampRowId', params.stampRowId, {});
    rb.query('stampRowType', params.stampRowType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserSelectionTagUserList>;
    })
  );
}

stampGetStampTagUserSelectionList.PATH = '/stamp/tag/user-selection/list';
